import { shallowEqual } from 'fast-equals';
import { ChainedSchema } from '../general/ChainedSchema';
import { dbEntityTypes } from './onlyDbEntities';
class SerializrType_withDefault extends ChainedSchema {
    serializedDefaultProvider;
    initForDbEntities;
    constructor(propSchema, serializedDefaultProvider, initForDbEntities) {
        super(propSchema);
        this.serializedDefaultProvider = serializedDefaultProvider;
        this.initForDbEntities = initForDbEntities;
    }
    isEqual_fast(s, sDefault) {
        if (typeof sDefault === 'object') {
            return shallowEqual(sDefault, s);
        }
        return s === sDefault;
    }
    serializer(context) {
        const serialized = this.parentSchema.serializer(context);
        const isDefault = this.isEqual_fast(serialized, this.serializedDefaultProvider);
        if (isDefault) {
            if (this.initForDbEntities && dbEntityTypes.includes(context.objectContext.target.type)) {
                return serialized;
            }
            return undefined;
        }
        return serialized;
    }
    deserializer(context) {
        if (context.json === null || context.json === undefined) {
            if (typeof this.serializedDefaultProvider === 'function') {
                context.json_overwrite = this.serializedDefaultProvider();
            }
            else {
                context.json_overwrite = this.serializedDefaultProvider;
            }
        }
        return this.parentSchema.deserializer(context);
    }
    get providesDefault() {
        return true;
    }
}
export function withDefault(propSchema, serializedDefaultProvider, initForDbEntities = false) {
    return new SerializrType_withDefault(propSchema, serializedDefaultProvider, initForDbEntities);
}
